module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic.3a6fd430.ttf";